export default {
    data: [
        {
            name: 'Bottom of the Well',
            search: ['Bottom of the Well'],
            icon: require('@/assets/map/shiekah.webp'),
            locations: [],
        },
        {
            name: 'Desert Colossus',
            search: ['Colossus', 'Desert Colossus'],
            icon: require('@/assets/map/gerudo.webp'),
            locations: [
                'Sheik at Colossus',
            ],
        },
        {
            name: 'Death Mountain Crater',
            search: ['DMC'],
            icon: require('@/assets/map/fire-medallion.webp'),
            locations: [
                'Sheik in Crater',
            ],
        },
        {
            name: 'Death Mountain Trail',
            search: ['DMT'],
            icon: require('@/assets/map/goron-ruby.webp'),
            locations: [
                'Fairy Gossip Stone',
            ],
        },
        {
            name: 'Deku Tree',
            search: ['Deku Tree'],
            icon: require('@/assets/map/kokiri-emerald.webp'),
            locations: [
                'Queen Gohma',
            ],
        },
        {
            name: 'Dodongos Cavern',
            search: ['Dodongos Cavern', 'Dodongo\'s Cavern'],
            icon: require('@/assets/map/goron-ruby.webp'),
            locations: [
                'King Dodongo',
            ],
        },
        {
            name: 'Fire Temple',
            search: ['Fire Temple'],
            icon: require('@/assets/map/fire-medallion.webp'),
            locations: [
                'Volvagia',
            ],
        },
        {
            name: 'Forest Temple',
            search: ['Forest Temple'],
            icon: require('@/assets/map/forest-medallion.webp'),
            locations: [
                'Phantom Ganon',
            ],
        },
        {
            name: 'Goron City',
            search: ['GC'],
            icon: require('@/assets/map/goron-ruby.webp'),
            locations: [],
        },
        {
            name: 'Gerudo Fortress',
            search: ['GF'],
            icon: require('@/assets/map/gerudo.webp'),
            locations: [],
        },
        {
            name: 'Gerudo Valley',
            search: ['GV', 'Gerudo Valley'],
            icon: require('@/assets/map/gerudo.webp'),
            locations: [],
        },
        {
            name: 'Graveyard',
            search: ['Graveyard', 'GY'],
            icon: require('@/assets/map/shiekah.webp'),
            locations: [
                'Song from Composers Grave',
                'Song from Royal Family\'s Tomb',
            ],
        },
        {
            name: 'Ganon\'s Castle',
            search: ['Ganon\'s Castle', 'OGC', 'Ganon\'s Tower'],
            icon: require('@/assets/map/ganon.webp'),
            locations: [
                'Ganon',
                'Ganondorf',
            ],
        },
        {
            name: 'Gerudo Training Ground',
            search: ['Gerudo Training Ground', 'Gerudo Training Grounds'],
            icon: require('@/assets/map/gerudo.webp'),
            locations: [],
        },
        {
            name: 'Hyrule Castle',
            search: ['HC'],
            icon: require('@/assets/map/hylia.webp'),
            locations: [
                'Song from Impa',
            ],
        },
        {
            name: 'Hyrule Field',
            search: ['HF'],
            icon: require('@/assets/map/hylia.webp'),
            locations: [
                'Song from Ocarina of Time',
            ],
        },
        {
            name: 'Ice Cavern',
            search: ['Ice Cavern'],
            icon: require('@/assets/map/zora-sapphire.webp'),
            locations: [
                'Sheik in Ice Cavern',
            ],
        },
        {
            name: 'Jabu Jabus Belly',
            search: ['Jabu Jabus Belly'],
            icon: require('@/assets/map/zora-sapphire.webp'),
            locations: [
                'Barinade',
            ],
        },
        {
            name: 'Kokiri Forest',
            search: ['KF'],
            icon: require('@/assets/map/kokiri-emerald.webp'),
            locations: [
                'Link\'s Pocket',
            ],
        },
        {
            name: 'Kakariko',
            search: ['Kak'],
            icon: require('@/assets/map/shiekah.webp'),
            locations: [
                'Sheik in Kakariko',
                'Song from Windmill',
            ],
        },
        {
            name: 'Lake Hylia',
            search: ['LH'],
            icon: require('@/assets/map/hylia.webp'),
            locations: [],
        },
        {
            name: 'Lon Lon Ranch',
            search: ['LLR'],
            icon: require('@/assets/map/lon-lon-ranch.webp'),
            locations: [
                'Song from Malon',
            ],
        },
        {
            name: 'Lost Woods',
            search: ['LW'],
            icon: require('@/assets/map/kokiri-emerald.webp'),
            locations: [
                'Deku Theater Mask of Truth',
                'Deku Theater Skull Mask',
            ],
        },
        {
            name: 'Market',
            search: ['Market', 'MK', 'ToT'],
            icon: require('@/assets/map/hylia.webp'),
            locations: [
                'Sheik at Temple',
                'Gift from Rauru',
            ],
        },
        {
            name: 'Sacred Forest Meadow',
            search: ['SFM'],
            icon: require('@/assets/map/kokiri-emerald.webp'),
            locations: [
                'Sheik in Forest',
                'Song from Saria',
            ],
        },
        {
            name: 'Shadow Temple',
            search: ['Shadow Temple'],
            icon: require('@/assets/map/shadow-medallion.webp'),
            locations: [
                'Bongo Bongo',
            ],
        },
        {
            name: 'Spirit Temple',
            search: ['Spirit Temple'],
            icon: require('@/assets/map/spirit-medallion.webp'),
            locations: [
                'Twinrova',
            ],
        },
        {
            name: 'Haunted Wasteland',
            search: ['Wasteland'],
            icon: require('@/assets/map/gerudo.webp'),
            locations: [],
        },
        {
            name: 'Water Temple',
            search: ['Water Temple'],
            icon: require('@/assets/map/water-medallion.webp'),
            locations: [
                'Morpha',
            ],
        },
        {
            name: 'Zora\'s Domain',
            search: ['ZD'],
            icon: require('@/assets/map/zora-sapphire.webp'),
            locations: [],
        },
        {
            name: 'Zora\'s Fountain',
            search: ['ZF'],
            icon: require('@/assets/map/zora-sapphire.webp'),
            locations: [
                'Jabu Gossip Stone',
            ],
        },
        {
            name: 'Zora\'s River',
            search: ['ZR'],
            icon: require('@/assets/map/zora-sapphire.webp'),
            locations: [],
        },
        {
            name: 'Triforce',
            search: [],
            icon: require('@/assets/triforce.webp'),
            locations: [
                'Completed Triforce'
            ],
            hidden: true,
        }
    ].sort((a, b) => a.name.localeCompare(b.name)),

    list() {
        return this.data.filter(a => !a.hidden)
    },
    find(location) {
        return this.data.find(a => a.search.some(s => location.startsWith(s)) || a.locations.includes(location))
    },
    get(area) {
        return this.data.find(a => a.name === area)
    },
}